import React, { useMemo, useState, useEffect } from "react";
import VaultTag from "../vault-tag";
import FTTag from "../ft-tag";
import styles from "./index.module.scss";
import { FlipperVaultCardProps } from "../flipper-vault-card";
import moment from "moment";
import ContactDropdown from "../flipper-vault-card/contact-dropdown";
import FlipperBottomBar from "../flipper-vault-card/bottombar";
import { Sidebar } from "primereact/sidebar";
import InvestorActivity from "../../../pages/invesetor-activity";
interface DropdownContact {
  name: string;
  code: string;
  email?: string;
  mobile?: string;
}

export default function FlipperVaultListItem({
  flipperData
}: {
  flipperData: FlipperVaultCardProps;
}) {
  const createdAt =
    flipperData?.checkouts?.[flipperData?.checkouts?.length - 1]?.createdAt;
  const [openActivity, setOpenActivity] = useState(false);
  const [showReleaseBtn, setShowReleaseBtn] = useState(
    createdAt &&
      -moment.utc(createdAt).diff(moment().utc(), "minutes") <=
        +`${process.env.REACT_APP_RELEASE_TIMER}`
      ? true
      : false
  );
  const [contact, setContact] = useState<DropdownContact | undefined>(
    flipperData?.contacts?.[0]
      ? {
          name: flipperData.contacts[0].name,
          code: flipperData.contacts[0].id,
          email: flipperData.contacts[0].email,
          mobile: flipperData.contacts[0].mobile
        }
      : undefined
  );
  const [isExpired, setIsExpired] = useState(
    flipperData?.checkouts !== null &&
      moment
        .utc(
          flipperData?.checkouts?.[flipperData?.checkouts?.length - 1]
            ?.expirtyAt
        )
        .isBefore(moment().utc())
  );

  const userDetail = useMemo(() => {
    const userObj = localStorage.getItem("user-detail");
    return userObj ? JSON.parse(userObj) : null;
  }, []);

  const hideInfo = useMemo(() => {
    return (
      flipperData?.owner?.[0]?.id !== userDetail?.id &&
      flipperData?.vaultOwnerId !== userDetail?.id &&
      (isExpired ||
        flipperData?.checkouts?.[flipperData?.checkouts?.length - 1]
          ?.releasedAt !== null)
    );
  }, [
    flipperData?.vaultOwnerId,
    userDetail?.id,
    isExpired,
    flipperData?.checkouts
  ]);
  const { checkouts, owner, vaultOwnerId } = flipperData;
  const lastCheckout = checkouts?.[checkouts?.length - 1];

  const vaultStatus = useMemo(() => {
    if (vaultOwnerId !== null) {
      if (vaultOwnerId === userDetail?.id) {
        // show My Vault
        return "MY VAULT";
      } else {
        return null;
      }
    } else {
      if (owner?.[0].id === userDetail?.id) {
        // owner and watching my account
        if (checkouts?.length > 0) {
          if (lastCheckout?.releasedAt !== null) {
            // have release data
            // show release by user Name in bottom bar and status will release
            return "RELEASED";
          } else if (isExpired) {
            // last checkout release date is null
            // check for expired condition
            // show expired by user name and status expired
            return "EXPIRED";
          } else {
            // show checked out by user name and timer in bottom bar and status will by checked out
            return "CHECKED OUT";
          }
        } else {
          // show nothing in bottom bar status also null
          return null;
        }
      } else {
        // not owner and watching other's account
        if (checkouts?.length > 0) {
          if (lastCheckout?.releasedAt !== null) {
            if (lastCheckout?.userId === userDetail?.id) {
              // checked out by me and released
              return "RELEASED";
            } else {
              // not checked out by me and released by other
              // can see checkout button
              if (flipperData?.hasCheckedOutByMe === "1") {
                return "LOCKED";
              }
              return null;
            }
          } else if (isExpired) {
            // release date is null
            // is expired
            if (lastCheckout?.userId === userDetail?.id) {
              // checked out by me and expired by me
              // show expiredd
              return "EXPIRED";
            } else {
              // show Locked
              return "LOCKED";
            }
          } else {
            if (lastCheckout?.userId === userDetail?.id) {
              // show release button and timer
              return "CHECKED OUT";
            } else {
              // show Locked
              return "LOCKED";
            }
          }
        } else {
          return null;
        }
      }
    }
  }, [flipperData, userDetail?.id, isExpired]);

  useEffect(() => {
    if (flipperData?.contacts?.[0]) {
      setContact({
        name: flipperData.contacts[0].name,
        code: flipperData.contacts[0].id,
        email: flipperData.contacts[0].email,
        mobile: flipperData.contacts[0].mobile
      });
    }
  }, [flipperData?.contacts]);

  return (
    <div
      className={`${styles.FlipperVaultListItem} ${
        vaultStatus === "LOCKED" ? styles.Locked : ""
      }`}
    >
      <div className={styles.FlipperVaultCardHeaderTags}>
        <FTTag status={flipperData.investorStatus} />
        <VaultTag
          status={vaultStatus}
          isLocked={vaultStatus === "MY VAULT" || vaultStatus === "LOCKED"}
        />
      </div>
      <div className={styles.FlipperVaultListTitle}>
        {/* {flipperData?.owner?.[0]?.id === userDetail?.id ||
        vaultStatus === "MY VAULT" ||
        vaultStatus === "CHECKED OUT"
          ? flipperData?.acctName
          : maskAccountName(flipperData?.acctName)} */}
        {flipperData?.acctName}
      </div>
      <div className={styles.FlipperVaultContactDropdown}>
        <ContactDropdown
          flipperData={flipperData}
          hideInfo={hideInfo || vaultStatus === "LOCKED"}
          contact={contact}
          setContact={setContact}
        />
        <div className={styles.FlipperVaultCardScore}>
          <div
            className={`${styles.FlipperVaultCardScoreValue} ${
              flipperData?.interestScore >= 50
                ? styles.Green
                : flipperData?.interestScore >= 30
                ? styles.Yellow
                : styles.Red
            }`}
          >
            {flipperData?.interestScore || 0}
          </div>
          INTEREST SCORE
        </div>
        <img
          src="/images/flipper-list-arrow.svg"
          alt=""
          className={
            flipperData?.owner?.[0]?.id === userDetail?.id ||
            vaultStatus === "MY VAULT" ||
            vaultStatus === "CHECKED OUT"
              ? ""
              : styles.disable
          }
          onClick={() => {
            if (
              flipperData?.owner?.[0]?.id === userDetail?.id ||
              vaultStatus === "MY VAULT" ||
              vaultStatus === "CHECKED OUT"
            ) {
              setOpenActivity(true);
            }
          }}
        />
        {flipperData?.owner?.[0]?.id === userDetail?.id ||
          vaultStatus === "MY VAULT" ||
          (vaultStatus === "CHECKED OUT" && (
            <Sidebar
              visible={openActivity}
              position="bottom"
              onHide={() => setOpenActivity(false)}
              className={styles.activityDrawer}
              maskClassName={styles.activityDrawerMask}
            >
              <InvestorActivity
                acctId={flipperData?.acctId}
                setOpenActivity={setOpenActivity}
                entityName={flipperData?.acctName}
              />
            </Sidebar>
          ))}
      </div>
      <div className={styles.FlipperVaultCardOwner}>
        <div className={styles.FlipperVaultCardOwnerTitle}>ACCOUNT OWNER</div>
        <div className={styles.FlipperVaultCardOwnerValue}>
          {flipperData?.owner ? flipperData?.owner?.[0].name : "N/A"}
        </div>
      </div>
      <div className={styles.bottomWrap}>
        <FlipperBottomBar
          showReleaseBtn={showReleaseBtn}
          setShowReleaseBtn={setShowReleaseBtn}
          type="list"
          flipperData={flipperData}
          userDetail={userDetail}
          setIsExpired={setIsExpired}
          isExpired={isExpired}
          setHideInfo={() => {}}
        />
      </div>
    </div>
  );
}
